import { Outlet } from 'react-router-dom';

// Om inloggning ska avnändas kan vi här lägga till om Outlet eller Login-page ska visas
export const PageRoutes = () => {
  return <Outlet />;
};
